import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import Select2Multiple from 'v-select2-multiple-component';
import CONFIG from "@/assets/js/config.custom.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';

export default {
    name: 'studentStatementList',
    components: {
        MainLayout,
        Loading,
        Select2Multiple,
        AdvancedLaravelVuePaginate,
    },

    data() {
        return {
            noDataMsg: CONFIG.NO_DATA_FOUND,
            studentInfo: {},
            searchData: {
                statement_type: CONFIG.STATEMENT_TYPE_IDS.CURRENT,
                is_search: 0,
            },
            academicYearArr: [],
            campusGradeArr: [],
            classArr: [],
            paymentPlanArr: CONFIG.PAYMENT_PLANS,
            STATEMENT_TYPES: CONFIG.STATEMENT_TYPE_IDS,
            statementData: {},
            disabled: false,
            isFilterOpen: false,
            isLoading: true,
        };
    },

    methods: {
        /**
         * get statement list (tuition_payments)
         * @param {bool} isSearch 
         * @param {int} page 
         */
        getStatementData(isSearch = 0, page = 1) {
            this.searchData.is_search = isSearch;
            this.isLoading = true;
            axios.get('student/statement/list?page=' + page, {
                params: this.searchData
            })
            .then(response => {
                if (response.data) {
                    this.statementData = response.data.student_statements;
                    this.isLoading = false;
                }
            })
            .catch(error => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                this.isLoading = false;
            });
        },

        /**
         * Get academic years list for academic year dropdown
         */
        getAcademicYears() {
            axios.get('period/periodList')
                .then(res => {
                    this.academicYearArr = res.data.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        /**
         * Clear search
         */
        reset() {
            this.searchData = {
                statement_type: CONFIG.STATEMENT_TYPE_IDS.CURRENT,
                is_search: 0,
            };
            this.isLoading = true;
            this.getStatementData();
        }
    },

    mounted() {
        this.isLoading = true;
        this.getAcademicYears();
        this.getStatementData();
    }
};
